import { call, put, takeEvery } from "redux-saga/effects"
import { CONNECTION_REQUEST} from "./actionTypes"
import { connectSuccess, connectFailed,updateAccountRequest } from "./actions"
import Web3EthContract from "web3-eth-contract";
import Web3 from "web3";

import { abiResponseService, configResponseService, web3ModalConnectService, web3CoinBaseService, web3getChainIdService,
  providerRequest1, providerRequest2 } from "../../services/blockchain-service";

 function* ConnectBlockchainSaga() {
    const abi =  yield call(abiResponseService);
    const CONFIG =  yield call(configResponseService)
    try {
          const provider =  yield call(web3ModalConnectService);
          // Add listeners start
          provider.on("accountsChanged", (accounts) => {
            console.log(accounts)
            // dispatch(updateAccountRequest(accounts[0]));
            // yield put(updateAccountRequest(accounts[0]))
          });

          Web3EthContract.setProvider(provider);
          let web3 = new Web3(provider);
    
    
          let account =  yield call(web3CoinBaseService, {web3});
          if (!account) {
             provider.request({ method: "eth_requestAccounts" });
            account =  yield call(web3CoinBaseService, {web3});
          }
    
          const chainId =  yield call(web3getChainIdService, {web3});
    
          if (chainId !== CONFIG.NETWORK.ID) {
            try {
              yield call (providerRequest1, {provider})
            } catch (err) {
              // if no chain found request to add
              if (err.code === 4902 || /Unrecognized chain ID/.test(err.message))
                yield call (providerRequest2, {provider})
              else {
                yield put(connectFailed(err))
              };
            }
          }
    
          const SmartContractObj = new Web3EthContract(
            abi,
            CONFIG.CONTRACT_ADDRESS
          );

          yield put(connectSuccess({
            account: account,
            smartContract: SmartContractObj,
            web3: web3,
          }))
      
    } catch (error) {
        console.log(error)
      yield put(connectFailed(error))
    }
  }


  function* blockChainSaga() {
    yield takeEvery(CONNECTION_REQUEST, ConnectBlockchainSaga)
  }
  
  export default blockChainSaga